import { useRecoilValue } from 'recoil'
import rolesAtom from '@/pages/Users/roles.atom.ts'

const useRoles = () => {
  const roles = useRecoilValue(rolesAtom).items

  return { roles }
}

export default useRoles
